module.exports = __webpack_public_path__ + "img/hospital.fcef1c9c.svg";